import * as React from "react"
import { Menu, X } from "lucide-react"
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from "../ui/dialog"
import { ThemeToggle } from "../ThemeToggle"
import { NavLink } from "react-router-dom"
import { SidebarContent } from "./Sidebar"

export function MobileNav({ user, onLogout }) {
  const [open, setOpen] = React.useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
        <button
          className="inline-flex items-center justify-center rounded-md min-w-11 min-h-11 w-11 h-11 text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground lg:hidden"
          aria-label="Ouvrir le menu"
        >
          <Menu className="h-5 w-5" />
        </button>
      </DialogTrigger>
      <DialogContent className="[&>button]:hidden translate-x-0 w-[300px] h-full max-h-screen p-0 fixed left-0 top-0 sm:w-[380px] rounded-none sm:rounded-none border-r-0 translate-y-0">
        <DialogTitle className="sr-only">Navigation mobile</DialogTitle>
        <DialogDescription className="sr-only">Menu de navigation principal</DialogDescription>
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b">
            <NavLink to="/" className="text-lg font-semibold hover:text-primary transition-colors">StockSights</NavLink>
            <button
              onClick={() => setOpen(false)}
              aria-label="Fermer le menu"
              className="rounded-md min-w-11 min-h-11 w-11 h-11 flex items-center justify-center hover:bg-accent"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="flex-1 overflow-auto py-2">
            {user ? (
              <SidebarContent onNavigate={() => setOpen(false)} />
            ) : (
              <div className="p-4">
                <NavLink
                  to="/login"
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-3 text-sm font-medium leading-5 bg-primary text-primary-foreground"
                >
                  Se connecter
                </NavLink>
              </div>
            )}
          </div>

          <div className="p-4 border-t space-y-3">
            <div className="flex items-center justify-between">
              <ThemeToggle />
              <span className="text-sm text-muted-foreground">Changer le thème</span>
            </div>
            {user && (
              <button
                onClick={() => { onLogout(); setOpen(false); }}
                className="w-full text-left px-3 py-3 text-sm text-destructive hover:bg-destructive/10 rounded-md transition-colors min-h-11"
              >
                Se déconnecter
              </button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
